function validate(values) {
  let errors = {};

  if (!values.quote) {
    errors.quote = "Please enter a quote.";
  }
  if (!values.quoted) {
    errors.quoted = "Please enter who said the quote.";
  }

  return errors;
}

export { validate };
